// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2sEEp","header":"Messages_header__2iOTy"};